module.exports = __webpack_public_path__ + "img/bb1.80f85c84.png";